<section class="qca-dashboard-page">
  <div class="page-shell">
    <header class="page-toolbar">
      <div>
        <h1>QCA Dashboard</h1>
      </div>
      
    <section class="filter-card" aria-label="Dashboard filters">
      <select aria-label="QCA"  [value]="selectedQca()" (change)="onQcaChange($any($event.target).value)">
        @for (qca of qcaOptions(); track qca.code) {
          <option [value]="qca.code" [selected]="qca.code === selectedQca()">{{ qca.name }}{{ qca.code !== "All" ? " (" + qca.code + ")" : "" }}</option>
        }
      </select>
      <select aria-label="PSS" [value]="selectedPss()" (change)="onPssChange($any($event.target).value)">
        @for (pss of pssOptions(); track pss.code) {
          <option [value]="pss.code" [selected]="pss.code === selectedPss()">{{ pss.name }}{{ pss.code !== "All" ? " (" + pss.code + ")" : "" }}</option>
        }
      </select>
      <input aria-label="Date" type="date" [value]="selectedDate()" (change)="selectedDate.set($any($event.target).value)" />
      <select aria-label="Time block" [value]="selectedTimeBlock()" (change)="onTimeBlockChange($any($event.target).value)">
        @for (block of timeBlockOptions; track block; let index = $index) {
          <option
            [value]="block"
            [selected]="block === selectedTimeBlock()"
          >
            Block {{ index + 1 }} · {{ block }}
          </option>
        }
      </select>
      <button class="primary-button" type="button" (click)="applyFilters()">
        Go
      </button>
      <button class="secondary-button" type="button" (click)="resetFilters()">
        Reset
      </button>
    </section>
    </header>


    <section class="stats-grid" aria-label="QCA summary">
      @for (kpi of kpis(); track kpi.label) {
        <article class="stat-card" [class]="kpi.tone">
          <span class="stat-icon">{{ kpi.icon }}</span>
          <div>
            <span class="stat-label">{{ kpi.label }}</span
            ><strong
              >{{ kpi.value }} <small>{{ kpi.unit }}</small></strong
            >
          </div>
        </article>
      }
    </section>

    
<section class="row g-2 mb-0 align-items-stretch">

  <!-- LEFT 10 COLUMNS -->
  <div class="col-10">

    <!-- TOP ROW: EMPTY 5 + GRAPH 5 -->
    <div class="row g-2 mb-1">

      <!-- GRAPH -->
      
      <div class="col-6">
                <article #injectionPanel class="panel chart-panel h-100">
          <div class="panel-heading">
            <div>
              <h2>Schedule vs Actual Injection</h2>
            </div>

            <div class="chart-header-actions">
              <div class="chart-filter">
                <label>
                  <span class="sr-only">Chart interval</span>
                  <select
                    aria-label="Chart interval"
                    [value]="injectionResolution()"
                    (change)="setInjectionResolution($any($event.target).value)"
                  >
                    <option value="hour">Hour</option>
                    <option value="block">Block</option>
                  </select>
                </label>
              </div>
              <button
                class="fullscreen-button"
                type="button"
                title="View injection chart in full screen"
                aria-label="View injection chart in full screen"
                (click)="toggleInjectionFullscreen()"
              >⛶</button>
            </div>
          </div>

          <div
            #injectionChart
            class="injection-highchart"
            aria-label="Interactive schedule versus actual injection graph"
          ></div>
        </article>
      </div>

       <!-- EMPTY SPACE -->
      <div class="col-6">
        <article class="panel payment-summary-panel h-100">
          <div class="panel-heading">
            <div>
              <h2>Payment Summary (YTD)</h2>
            </div>
          </div>

          <div class="payment-summary-content">
            <div class="payment-chart-wrap">
              <div
                #paymentChart
                class="payment-highchart"
                aria-label="Year-to-date payment summary donut chart"
              ></div>
              <div class="payment-chart-total" aria-hidden="true">
                <span>Total Paid</span>
                <strong>{{ formatCurrency(paymentSummaryTotal()) }}</strong>
              </div>
            </div>

            <div class="payment-breakdown">
              @for (payment of source.paymentSummaryYtd; track payment.label) {
                <div class="payment-breakdown-row">
                  <span
                    class="payment-swatch"
                    [style.background]="payment.color"
                    aria-hidden="true"
                  ></span>
                  <span class="payment-label">{{ payment.label }}</span>
                  <strong class="payment-amount">
                    {{ formatCurrency(payment.amount) }}
                    <small>({{ paymentShare(payment.amount) }}%)</small>
                  </strong>
                </div>
              }
            </div>
          </div>
        </article>
      </div>

    </div>


    <!-- TABLE: FULL LEFT 10 COLUMNS -->
    <div class="row g-2">

      <div class="col-12">
        <article class="panel revisions-panel">

          <div class="panel-heading">
            <div>
              <h2>Revisions in Schedule &amp; AvC</h2>
            </div>

            <button class="link-button" type="button">
              View All
            </button>
          </div>

          <div
            class="table-wrap compact-table"
            (scroll)="loadMoreRevisionRows($event)"
          >
            <table>
              <thead>
                <tr>
                  <th rowspan="2">Sr. No.</th>
                  <th rowspan="2">PSS ID</th>
                  <th rowspan="2">PSS Name</th>
                  <th rowspan="2">Revision Type</th>
                  <th rowspan="2">Time Block</th>
                  <th rowspan="2">Submitted At</th>

                  <th colspan="1">Schedule (MW) <br> <small>Compared with Previous Block</small></th>
                  <th colspan="1">AvC (MW) <br> <small>Compared with Previous Block</small></th>

                  <th rowspan="2">Submitted By</th>
                  <th rowspan="2">Status</th>
                </tr>

                <tr class="subhead">
                  <th>Change (MW)</th>
                  <th>Change (MW)</th>
                </tr>
              </thead>

              <tbody style="font-size: 12px;">
                @for (row of visibleRevisionRows(); let index = $index; track row.id) {

                  <tr>
                    <td>{{ index + 1 }}</td>

                    <td>
                      <button
                        class="table-link"
                        type="button"
                        (click)="selectPss(row.pssCode)"
                      >
                        {{ row.pssCode }}
                      </button>
                    </td>

                    <td>
                      <button
                        class="table-link name-link"
                        type="button"
                        (click)="selectPss(row.pssCode)"
                      >
                        {{ pssName(row.pssCode) }}
                      </button>
                    </td>

                    <td>{{ row.revisionType }}</td>
                    <td>{{ row.timeBlock }}</td>
                    <td>{{ row.submittedAt }}</td>

                    <td>
                      <div class="revision-change-cell">
                        <span class="revision-value">{{ formatMw(row.scheduleMw) }}</span>
                        <span
                          class="revision-delta"
                          [class.positive-text]="row.scheduleChangeMw > 0"
                          [class.negative-text]="row.scheduleChangeMw < 0"
                        >
                          @if (row.scheduleChangeMw > 0) {
                            <span class="change-icon positive">
                              <svg viewBox="0 0 20 20" aria-hidden="true">
                                <circle cx="10" cy="10" r="9" />
                                <path d="M6 14L14 6M8 6H14V12" />
                              </svg>
                            </span>
                          } @else if (row.scheduleChangeMw < 0) {
                            <span class="change-icon negative">
                              <svg viewBox="0 0 20 20" aria-hidden="true">
                                <circle cx="10" cy="10" r="9" />
                                <path d="M6 6L14 14M8 14H14V8" />
                              </svg>
                            </span>
                          }
                          {{ row.scheduleChangeMw > 0 ? "+" : "" }}{{ formatMw(row.scheduleChangeMw) }}
                        </span>
                      </div>
                    </td>

                  

                    <td>
                      <div class="revision-change-cell">
                        <span class="revision-value">{{ formatMw(row.avcMw) }}</span>
                        <span
                          class="revision-delta"
                          [class.positive-text]="row.avcChangeMw > 0"
                          [class.negative-text]="row.avcChangeMw < 0"
                        >
                          @if (row.avcChangeMw > 0) {
                            <span class="change-icon positive">
                              <svg viewBox="0 0 20 20" aria-hidden="true">
                                <circle cx="10" cy="10" r="9" />
                                <path d="M6 14L14 6M8 6H14V12" />
                              </svg>
                            </span>
                          } @else if (row.avcChangeMw < 0) {
                            <span class="change-icon negative">
                              <svg viewBox="0 0 20 20" aria-hidden="true">
                                <circle cx="10" cy="10" r="9" />
                                <path d="M6 6L14 14M8 14H14V8" />
                              </svg>
                            </span>
                          }
                          {{ row.avcChangeMw > 0 ? "+" : "" }}{{ formatMw(row.avcChangeMw) }}
                        </span>
                      </div>
                    </td>

                    

                    <td>{{ row.submittedBy }}</td>

                    <td>
                      <span class="status-pill approved">
                        {{ row.status }}
                      </span>
                    </td>
                  </tr>

                }
              </tbody>
            </table>
          </div>

        </article>
      </div>

    </div>

  </div>


  <!-- RIGHT 2 COLUMNS - FULL HEIGHT -->
  <div class="col-2 d-flex">

    <article class="panel alerts-panel h-100 w-100">

      <div class="panel-heading">
        <div>
          <h2>Recent Alerts</h2>
        </div>

        <button class="link-button" type="button">
          View All
        </button>
      </div>

      <div class="alerts-list">
        @for (alert of source.alerts; track alert.title) {

          <div
            class="alert-row"
            [class]="alertClass(alert)"
          >
            <span class="alert-icon" aria-hidden="true">
              @if (alert.level === "success") {
                <svg viewBox="0 0 16 16"><path d="m3.5 8.25 2.75 2.75 6.25-6.5" /></svg>
              } @else if (alert.level === "info") {
                <svg viewBox="0 0 16 16"><circle cx="8" cy="8" r="5.5" /><path d="M8 7v3.25M8 5.25h.01" /></svg>
              } @else {
                <svg viewBox="0 0 16 16"><path d="M8 3.25v5.5M8 11.5h.01" /></svg>
              }
            </span>

            <div class="alert-content">
              <strong>{{ alertTitle(alert.title) }}</strong>
              <p>{{ alert.detail }}</p>
            </div>
            <time>{{ alert.dateTime }}</time>

          </div>

        }
      </div>

    </article>

  </div>

</section>


  </div>
</section>
